export default "__VITE_ASSET__BzB4nyYC__"